import React from "react";
import { Modal } from "react-bootstrap";
import "../../../assets/css/dashboard.css";
import AddGroup from "../forms/Add_User_Group"

const AddUserGroup = (props) => {
  return (
    <div>
      <Modal
         show={props.show}
         onHide={props.onHide}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="text-grey">Add a User Group</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddGroup fetch_user_groups={props.fetch_user_groups}/>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddUserGroup;
